<template>
  <b-row class="justify-content-center">
    <b-col
      cols="12"
      sm="6"
    >
      <b-form-group>
        <b-button
          :href="url"
          type="button"
          block
          class="login-btn "
          :class="name"
        >
          <b-icon
            :icon="name"
            class="mr-2"
          />
          {{ buttonTxt }}
        </b-button>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ConnectButton',
  props: {
    url: String,
    name: String,
    buttonTxt: String,
  }
}
</script>

<style lang='less'>
.login-btn {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &.facebook {
    background-color: #4267B2;

    &:hover, &:active {
      background-color: #1e4ca8 !important;
    }
  }

  &.google { 
    background-color: #DB4437;

    &:hover, &:active {
      background-color: #cd3021 !important;
    }
  }

  &.twitter { 
    background-color: #1DA1F2;

    &:hover, &:active {
      background-color: #087fc9 !important;
    }
  }
}
</style>